/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { ChevronRight } from '@material-ui/icons';
import { DnDSource } from 'react-big-scheduler';

import '../DnDTable/DnDTable.scss';
import {
  fetchJobDetails,
  checkPermission,
} from '../../_helpers/commonFunctions';
import getJobListAction, {
  getMissedJobListAction,
  getNextMonthJobListAction,
} from '../../redux/actions/jobLinkActions';
import { subPermissions } from '../../libs/constants/permissions';
import {
  runCoachMarks,
  toggleCoachmarksVisibility,
} from '../../redux/actions/signUp';
import CustomDropDown from '../ReallyCustomDropDown';
import DropdownSelect from '../../components_2/DropdownSelect';
import SearchInput from '../../components_2/SearchInput';
import dragTypes from '../../libs/constants/dragTypes';

import JobListRow from './JobListRow.jsx';
import FloatingMap from './FloatingMap.jsx';
import MiniMap from './MiniMap.jsx';
import './joblinkMap.scss';

const listOptions = [
  { value: 'dueThisMonth', label: 'Due this month' },
  { value: 'missedInspections', label: 'Missed Inspections' },
  { value: 'dueNextMonth', label: 'Due next month' },
  { value: 'all', label: 'All' },
];
export class JobListMap extends Component {
  static closeJobListMap = () => {
    if (JobListMap.instance) {
      JobListMap.instance.closeJobListMap();
    }
  };
  constructor(props) {
    super(props);
    this.state = {
      isJobListOpen: false,
      searchValue: '',
      jobs: [],
      missedJob: [],
      nextMonthJob: [],
      selectedCategories: [],
      defaultList: 'dueThisMonth',
      showingInfoWindow: false,
      selectedPlace: '',
      geocodedJobs: [],
      currentLocation: { lat: 0, lng: 0 },
      sharedMapCenter: null,
      sharedMapZoom: null,
      isFloating: false,
      mapOpenCount: 0,
      mapTaskDndSource: new DnDSource(
        (props1) => props1.task,
        (props1) => <JobListRow {...props1} isFromMap={true} />,
        dragTypes.TASK
      ),
    };
    this.markerRefs = {};
    this.isViewJobs = checkPermission(subPermissions.viewJobsDueMissed);

    this.isDraggingGlobally = false;
    this.dragPreview = null;
    this.draggedJob = null;
    this.savedCurrentLocation = null;
    this.map = null;
    this.isGeocodingInProgress = false;
  }

  //* global drag and drop handlers *//

  startGlobalDrag = (job, googleMapsEvent) => {
    this.savedCurrentLocation = { ...this.map.getCenter().toJSON() };
    console.log('=== MAP DRAG START DEBUG ===');
    console.log('Starting drag for job:', job);
    console.log('TaskDndSource:', this.props.taskDndSource);
    console.log('MapTaskDndSource:', this.state.mapTaskDndSource);

    const preview = this.createDragPreview(job);
    document.body.appendChild(preview);

    this.isDraggingGlobally = true;
    this.dragPreview = preview;
    this.draggedJob = job;

    document.addEventListener('mousemove', this.handleGlobalMouseMove);
    document.addEventListener('mouseup', this.handleGlobalMouseUp);

    const MapDnDTaskItem = this.state.mapTaskDndSource.getDragSource();
    if (MapDnDTaskItem && this.props.taskDndSource) {
      console.log('=== Activating drag in react-big-scheduler ===');
      const fakeEvent = {
        dataTransfer: {
          setData: (type, data) => {},
          effectAllowed: 'move',
        },
        target: this.markerRefs[job.id],
        clientX: 0,
        clientY: 0,
      };

      // Activar el drag en react-big-scheduler
      if (this.props.taskDndSource.beginDrag) {
        console.log('=== Calling taskDndSource.beginDrag ===');
        this.props.taskDndSource.beginDrag(job, fakeEvent);
      }
    } else {
      console.warn('=== MapDnDTaskItem or taskDndSource not available ===');
    }
  };

  createDragPreview = (job) => {
    const preview = document.createElement('div');
    preview.style.cssText = `
      position: fixed;
      pointer-events: none;
      z-index: 10000;
      background: ${this.getMarkerColor(job.type)};
      min-width: 80px;
      height: 30px;
      border-radius: 4px;
      color: white;
      padding: 5px;
      font-size: 12px;
      box-shadow: 0 4px 8px rgba(0,0,0,0.3);
      transform: translate(-50%, -50%);
    `;
    preview.textContent = `${job.customerName || 'Job'} #${job.jobId}`;
    return preview;
  };

  handleGlobalMouseMove = (e) => {
    if (!this.isDraggingGlobally || !this.dragPreview) return;

    this.dragPreview.style.left = e.clientX + 'px';
    this.dragPreview.style.top = e.clientY + 'px';

    const dropTarget = this.findDropTarget(e.clientX, e.clientY);
    if (dropTarget) {
      dropTarget.classList.add('drag-over');
    }
  };

  handleGlobalMouseUp = (e) => {
    console.info('Global mouse up detected', {
      isDraggingGlobally: this.isDraggingGlobally,
    });
    if (!this.isDraggingGlobally) return;

    const dropTarget = this.findDropTarget(e.clientX, e.clientY);
    if (dropTarget && this.draggedJob) {
      console.info(
        'Global drop detected on target:',
        dropTarget,
        this.draggedJob
      );
      this.handleDrop(this.draggedJob, dropTarget, e);
    } else {
      console.info(
        'Global drop outside valid target',
        dropTarget,
        this.draggedJob
      );
    }

    document.removeEventListener('mousemove', this.handleGlobalMouseMove);
    document.removeEventListener('mouseup', this.handleGlobalMouseUp);

    if (this.dragPreview?.parentNode) {
      try {
        this.dragPreview.parentNode.removeChild(this.dragPreview);
      } catch (error) {
        console.warn('Error removing drag preview:', error);
      }
    }

    this.endGlobalDrag();
  };

  findDropTarget = (x, y) => {
    const elements = document.elementsFromPoint(x, y);

    return elements.find(
      (el) =>
        el.classList.contains('timeline-slot') ||
        el.classList.contains('resource-view') ||
        el.classList.contains('scheduler-content') ||
        el.classList.contains('rbs-content-cell')
    );
  };

  calculateDropPosition = (dropTarget, event) => {
    console.log('=== CALCULATING DROP POSITION ===');

    const schedulerData = this.props.schedulerData;
    console.log('SchedulerData:', {
      startDate: schedulerData.startDate,
      endDate: schedulerData.endDate,
      viewType: schedulerData.viewType,
      config: schedulerData.config,
      headers: schedulerData.headers?.length,
    });

    const rect = dropTarget.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    console.log('Drop position:', {
      x,
      y,
      clientX: event.clientX,
      clientY: event.clientY,
    });
    console.log('Target rect:', rect);

    const resources = schedulerData.resources;
    console.log('Resources:', resources);

    const renderData = schedulerData.renderData || [];
    const resourceHeight =
      renderData.length > 0 ? rect.height / renderData.length : 60;
    const resourceIndex = Math.floor(y / resourceHeight);
    const resource = resources[resourceIndex] || resources[0];

    console.log('Resource calculation:', {
      resourceHeight,
      resourceIndex,
      selectedResource: resource,
    });

    const headers = schedulerData.headers || [];
    console.log('Headers sample:', headers.slice(0, 3));

    if (headers.length > 0) {
      const headerWidth = rect.width / headers.length;
      const headerIndex = Math.floor(x / headerWidth);
      const selectedHeader = headers[headerIndex] || headers[0];

      console.log('Header calculation:', {
        headerWidth,
        headerIndex,
        selectedHeader: selectedHeader?.time,
      });

      const dropTime = moment(selectedHeader.time);
      const startTime = dropTime.format('YYYY-MM-DD HH:mm:ss');
      const endTime = dropTime
        .clone()
        .add(30, 'minutes')
        .format('YYYY-MM-DD HH:mm:ss');

      console.log('Calculated times:', { startTime, endTime });

      return {
        slotId: resource.id,
        slotName: resource.name,
        startTime,
        endTime,
      };
    } else {
      const startDate = moment(schedulerData.startDate);
      const cellWidth = rect.width / 24;
      const hoursFromStart = Math.floor(x / cellWidth);

      const dropTime = startDate.clone().add(hoursFromStart, 'hours');
      const startTime = dropTime.format('YYYY-MM-DD HH:mm:ss');
      const endTime = dropTime
        .clone()
        .add(30, 'minutes')
        .format('YYYY-MM-DD HH:mm:ss');

      console.log('Fallback calculation:', {
        startDate: startDate.format(),
        cellWidth,
        hoursFromStart,
        startTime,
        endTime,
      });

      return {
        slotId: resource.id,
        slotName: resource.name,
        startTime,
        endTime,
      };
    }
  };

  handleDrop = (job, dropTarget, event) => {
    console.log('=== MAP DROP DEBUG ===');
    console.log('Dropped job:', job);
    console.log('Drop target:', dropTarget);
    console.log('Drop target:', event);

    if (this.props.newEvent && this.props.schedulerData) {
      console.info('=== CALLING newEvent FROM MAP ===');

      try {
        const dropPosition = this.calculateDropPosition(dropTarget, event);

        console.log('=== MAP newEvent parameters ===');
        console.log('schedulerData:', this.props.schedulerData);
        console.log('slotId:', dropPosition.slotId);
        console.log('slotName:', dropPosition.slotName);
        console.log('start:', dropPosition.startTime);
        console.log('end:', dropPosition.endTime);
        console.log('type: task');
        console.log('resizing:', job);
        console.log('task:', job);

        this.props.newEvent(
          this.props.schedulerData,
          dropPosition.slotId,
          dropPosition.slotName,
          dropPosition.startTime,
          dropPosition.endTime,
          'task',
          job,
          job
        );

        console.log('=== newEvent called successfully ===');
        this.removeJobFromMap(job.id);
      } catch (error) {
        console.error('=== ERROR in newEvent ===', error);
        console.error('Error stack:', error.stack);
      }
    } else {
      console.warn('=== newEvent or schedulerData not available ===');
    }
  };

  removeJobFromMap = (jobId) => {
    this.setState((prevState) => ({
      jobs: prevState.jobs.filter((job) => job.id !== jobId),
      missedJob: prevState.missedJob.filter((job) => job.id !== jobId),
      nextMonthJob: prevState.nextMonthJob.filter((job) => job.id !== jobId),
      geocodedJobs: prevState.geocodedJobs.filter((job) => job.id !== jobId),
    }));
  };

  endGlobalDrag = () => {
    if (this.savedCurrentLocation) {
      this.setState({ currentLocation: this.savedCurrentLocation });
      this.map.panTo(this.savedCurrentLocation);
    }
    console.info('Ending global drag');
    document.querySelectorAll('.drag-over').forEach((el) => {
      el.classList.remove('drag-over');
    });

    this.isDraggingGlobally = false;
    this.dragPreview = null;
    this.draggedJob = null;
  };

  //* global drag and drop handlers *//

  /**
   * sets new jobs in state
   *
   * @memberof JobListMap
   */
  setJobs = () => {
    const { missedJobs, nextMonthJobs } = this.props;
    const { jobList } = this.props.jobList;
    const jobs = fetchJobDetails(jobList, true);
    const missedJob = fetchJobDetails(missedJobs.jobList, true);
    const nextMonthJob = fetchJobDetails(nextMonthJobs.jobList, true);

    console.info(
      'Setting jobs - jobs:',
      jobs.length,
      'missed:',
      missedJob.length,
      'next:',
      nextMonthJob.length
    );

    this.setState({ jobs, missedJob, nextMonthJob }, () => {
      this.geocodeJobs();
    });
  };

  /**
   * Fetches due this month jobs list
   *
   * @memberof JobListMap
   */
  getJobList = (queryParams = {}, page = null) => {
    console.info('Fetching jobs with params:', queryParams, 'Page:', page);
    this.props.getJobListAction(
      {
        ...queryParams,
        startDate: moment().startOf('day').valueOf(),
        endDate: moment().endOf('month').valueOf(),
      },
      !page ? this.props.jobList.currentPage + 1 : page,
      100
    );
  };

  /**
   * Fetches missed jobs list
   *
   * @memberof JobListMap
   */
  getMissedJobList = (queryParams = {}, page = null) => {
    this.props.getMissedJobListAction(
      queryParams,
      !page ? this.props.missedJobs.currentPage + 1 : page,
      100
    );
  };

  /**
   * Fteches due next month jobs list
   *
   * @memberof JobListMap
   */
  getDueNextMonthJobList = (queryParams = {}, page = null) => {
    this.props.getNextMonthJobListAction(
      queryParams,
      !page ? this.props.nextMonthJobs.currentPage + 1 : page,
      100
    );
  };

  /**
   * Sets search text with debouncing
   *
   * @param {object} e
   * @memberof JobListMap
   */
  setSearchText = (e) => {
    const searchValue = e.target ? e.target.value : '';
    this.setState({ searchValue });

    // Clear previous timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Debounce search - wait 300ms after user stops typing
    this.searchTimeout = setTimeout(() => {
      this.applyAllFilters();
    }, 300);
  };

  /**
   * Applies all current filters and fetches data from backend
   *
   * @memberof JobListMap
   */
  applyAllFilters = () => {
    const { selectedCategories, searchValue, defaultList } = this.state;

    // Build query parameters combining all filters
    const queryParams = {};

    if (selectedCategories.length) {
      queryParams.reportCategory = selectedCategories;
    }

    if (searchValue.trim()) {
      queryParams.search = searchValue.trim();
    }

    // Apply date filters based on defaultList selection
    const now = moment();
    switch (defaultList) {
      case 'dueThisMonth':
        queryParams.startDate = now.startOf('month').valueOf();
        queryParams.endDate = now.endOf('month').valueOf();
        break;
      case 'dueNextMonth': {
        const nextMonth = now.clone().add(1, 'month');
        queryParams.startDate = nextMonth.startOf('month').valueOf();
        queryParams.endDate = nextMonth.endOf('month').valueOf();
        break;
      }
      case 'missedInspections':
        queryParams.endDate = now.startOf('day').valueOf();
        queryParams.missed = true;
        break;
      case 'all':
        // No date restrictions for 'all'
        break;
      default:
        // No date restrictions for default
        break;
    }

    console.info('Applying filters with params:', queryParams);

    // Fetch data based on current filter selection
    if (defaultList === 'missedInspections') {
      this.getMissedJobList(queryParams, 1);
    } else if (defaultList === 'dueNextMonth') {
      this.getDueNextMonthJobList(queryParams, 1);
    } else {
      // For 'dueThisMonth' and 'all'
      this.getJobList(queryParams, 1);
      if (defaultList === 'all') {
        // Also fetch missed and next month for 'all' view
        this.getMissedJobList({ ...queryParams, missed: true }, 1);
        this.getDueNextMonthJobList(
          {
            ...queryParams,
            startDate: moment().add(1, 'month').startOf('month').valueOf(),
            endDate: moment().add(1, 'month').endOf('month').valueOf(),
          },
          1
        );
      }
    }
  };

  /**
   * Handles job searching (legacy method - now calls applyAllFilters)
   *
   * @memberof JobListMap
   */
  handleSearch = () => {
    this.applyAllFilters();
  };

  /**
   * Updates selected categories and applies all filters
   *
   * @param {Array} selectedCategories
   * @memberof JobListMap
   */
  fetchCategories = (selectedCategories) => {
    console.info('Updating categories:', selectedCategories);
    this.setState({ selectedCategories }, () => {
      // Immediately re-geocode with current data filtered by new categories
      this.geocodeJobs();
      // Then fetch new data from backend
      this.applyAllFilters();
    });
  };

  /**
   * Updates date filter and applies all filters
   *
   * @param {string} filterType
   * @memberof JobListMap
   */
  updateDateFilter = (filterType) => {
    console.info('Updating date filter:', filterType);
    this.setState({ defaultList: filterType }, () => {
      this.applyAllFilters();
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isJobListOpen && this.state.isJobListOpen) {
      // Set flag to fit map on next MiniMap mount, then increment counter to force remount
      this.shouldFitOnNextMount = true;
      this.setState(prev => ({ mapOpenCount: prev.mapOpenCount + 1 }));
    }
    // Check if job data has changed
    const jobListChanged =
      prevProps.jobList.jobList !== this.props.jobList.jobList;
    const missedJobsChanged =
      prevProps.missedJobs.jobList !== this.props.missedJobs.jobList;
    const nextMonthJobsChanged =
      prevProps.nextMonthJobs.jobList !== this.props.nextMonthJobs.jobList;

    // Check if any job list has been updated
    if (jobListChanged || missedJobsChanged || nextMonthJobsChanged) {
      console.info('Job data changed, updating state and map');
      this.setJobs();
    }

    // Check permission changes
    if (checkPermission(subPermissions.viewJobsDueMissed) !== this.isViewJobs) {
      this.isViewJobs = checkPermission(subPermissions.viewJobsDueMissed);
      this.applyAllFilters();
    }
  }

  getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.setState({
            currentLocation: {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            },
          });
        },
        (error) => {
          console.warn('Error getting location:', error);
        }
      );
    }
  };

  waitForGoogleMaps = () => {
    return new Promise((resolve) => {
      const checkGoogle = () => {
        if (window.google?.maps?.Geocoder) {
          resolve(true);
        } else {
          setTimeout(checkGoogle, 100);
        }
      };
      checkGoogle();
    });
  };

  geocodeJobs = async () => {
    if (this.isGeocodingInProgress) {
      return;
    }

    this.isGeocodingInProgress = true;
    await this.waitForGoogleMaps();
    const { jobs, missedJob, nextMonthJob, defaultList, selectedCategories } =
      this.state;

    let jobsToGeocode = [];

    switch (defaultList) {
      case 'dueThisMonth':
        jobsToGeocode = jobs;
        break;
      case 'missedInspections':
        jobsToGeocode = missedJob;
        break;
      case 'dueNextMonth':
        jobsToGeocode = nextMonthJob;
        break;
      case 'all':
        jobsToGeocode = [...jobs, ...missedJob, ...nextMonthJob];
        break;
      default:
        jobsToGeocode = jobs;
    }

    if (selectedCategories.length > 0) {
      jobsToGeocode = jobsToGeocode.filter((job) =>
        selectedCategories.includes(job.reportCategory)
      );
    }

    const geocodePromises = jobsToGeocode.map(async (job) => {
      const { address } = job;
      if (address) {
        const coords = job.allDetails?.coordinates;
        console.info({ coords, job });
        if (coords) {
          return {
            ...job,
            geocodedCoords: coords,
          };
        }
      }
      return null;
    });

    const geocodedResults = await Promise.all(geocodePromises);
    const geocodedJobs = geocodedResults.filter((job) => job !== null);

    console.info(
      'Geocoding completed, geocoded jobs count:',
      geocodedJobs.length
    );
    this.setState({ geocodedJobs });

    this.isGeocodingInProgress = false;
  };

  centerMapToAllMarkers = () => {
    if (!this.map || this.state.geocodedJobs.length === 0) return;

    try {
      const bounds = new globalThis.google.maps.LatLngBounds();

      // Incluir la ubicación actual
      bounds.extend(this.state.currentLocation);

      // Encontrar los pines más extremos para optimizar el cálculo
      const coords = this.state.geocodedJobs
        .map((job) => job.geocodedCoords)
        .filter(Boolean);

      if (coords.length > 0) {
        const extremes = coords.reduce(
          (acc, coord) => {
            if (coord.lat > acc.north.lat) acc.north = coord;
            if (coord.lat < acc.south.lat) acc.south = coord;
            if (coord.lng > acc.east.lng) acc.east = coord;
            if (coord.lng < acc.west.lng) acc.west = coord;
            return acc;
          },
          {
            north: coords[0],
            south: coords[0],
            east: coords[0],
            west: coords[0],
          }
        );

        // Solo incluir los puntos extremos
        for (const coord of Object.values(extremes)) {
          bounds.extend(coord);
        }
      }
      setTimeout(() => {
        this.map.fitBounds(bounds, { padding: 0 });
        setTimeout(() => {
          const currentZoom = this.map.getZoom();
          this.map.setZoom(currentZoom - 1);
        }, 150);
      }, 150);
    } catch (error) {
      console.warn('Error centering map to markers:', error);
    }
  };

  fitMapToMarkers = () => {
    this.centerMapToAllMarkers();
  };

  getMarkerColor = (jobType) => {
    const type = jobType?.toLowerCase();
    if (type === 'inspection') {
      return '#dc2626'; // red
    } else if (type === 'work order') {
      return '#2563eb'; // blue
    } else if (type === 'quote') {
      return '#16a34a'; // green
    }
    return '#eab308'; // yellow
  };

  getAllJobsWithCoordinates = () => {
    // Since filtering is now done on the backend, just return all geocoded jobs
    // The backend already filtered the data based on our query parameters
    return this.state.geocodedJobs;
  };

  onMarkerClick = (job) => {
    this.setState({
      selectedPlace: job,
      showingInfoWindow: true,
    });
  };

  onInfoWindowClose = () => {
    this.setState({
      showingInfoWindow: false,
      selectedPlace: '',
    });
  };

  closeJobListMap = () => this.setState({ isJobListOpen: false }); // NOSONAR: Method to close the JobListMap from outside

  toggleFloatingMode = () => {
    // Save current map position before switching
    let savedCenter = null;
    let savedZoom = null;
    
    if (this.map) {
      try {
        const center = this.map.getCenter();
        savedCenter = center ? { lat: center.lat(), lng: center.lng() } : null;
        savedZoom = this.map.getZoom();
      } catch (e) {
        console.warn('Could not get map position:', e);
      }
    }
    
    this.setState(
      (prevState) => ({ 
        isFloating: !prevState.isFloating,
        sharedMapCenter: savedCenter,
        sharedMapZoom: savedZoom,
      }),
      () => {
        // Map reference will be updated by onMapReady of the new map
        this.map = null;
      }
    );
  };

  handleFullscreenChange = () => {
    if (this.map) {
      const currentCenter = this.map.getCenter();
      const currentZoom = this.map.getZoom();

      setTimeout(() => {
        globalThis.google?.maps?.event?.trigger(this.map, 'resize');
        this.map.setCenter(currentCenter);
        this.map.setZoom(currentZoom);
      }, 1000);
    }
  };

  componentDidMount() {
    JobListMap.instance = this;
    this.shouldFitOnNextMount = true;
    this.getCurrentLocation();

    if (
      this.props.jobList?.jobList?.length > 0 ||
      this.props.missedJobs?.jobList?.length > 0 ||
      this.props.nextMonthJobs?.jobList?.length > 0
    ) {
      this.setJobs();
    } else {
      this.applyAllFilters();
    }

    if (this.props.onMapTaskDndSourceReady) {
      this.props.onMapTaskDndSourceReady(this.state.mapTaskDndSource);
    }

    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
  }

  componentWillUnmount() {
    JobListMap.instance = null;

    // Clear search timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    // Limpiar event listeners globales si existen
    document.removeEventListener('mousemove', this.handleGlobalMouseMove);
    document.removeEventListener('mouseup', this.handleGlobalMouseUp);
    document.removeEventListener(
      'fullscreenchange',
      this.handleFullscreenChange
    );

    // Limpiar drag preview si existe
    if (this.dragPreview?.parentNode) {
      try {
        this.dragPreview.parentNode.removeChild(this.dragPreview);
      } catch (error) {
        console.warn('Error removing drag preview in cleanup:', error);
      }
    }
  }

  render() {
    const {
      isJobListOpen,
      searchValue,
      defaultList,
      currentLocation,
      isFloating,
    } = this.state;
    const { handleClickJobListItem, currentCoachmarkTarget, intl } = this.props;

    // Translate report categories
    const translatedReportCategories = (this.props.reportCategories || []).map((value) => ({
      value,
      label: intl.formatMessage({ id: value, defaultMessage: value }),
    }));

    // Translate list options
    const translatedListOptions = listOptions.map((option) => ({
      value: option.value,
      label: intl.formatMessage({ id: option.label, defaultMessage: option.label }),
    }));

    const jobsLists = (
      <div className="p-3 border-md mt-2 bg-white rounded-md w-72 sm:w-80">
        <SearchInput
          onSearch={this.handleSearch}
          onChange={this.setSearchText}
          value={searchValue}
          placeholder={intl.formatMessage({
            id: 'Search',
            defaultMessage: 'Search',
          })}
        />
        <DropdownSelect
          multiple={true}
          allowClear
          placeholder={intl.formatMessage({
            id: 'Filter by category',
            defaultMessage: 'Filter by category',
          })}
          onChange={({ target }) => {
            this.fetchCategories(target.value);
          }}
          value={this.state.selectedCategories}
          options={translatedReportCategories}
          className="mt-2"
        />
        <DropdownSelect
          value={defaultList}
          options={translatedListOptions}
          onChange={({ target }) => {
            this.updateDateFilter(target.value);
          }}
          className="mt-2"
        />
        <div className="w-72 h-100">
          <br></br>
          {currentLocation.lat === 0 && currentLocation.lng === 0 ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>Loading map...</span>
              <div 
                style={{ 
                  width: '16px', 
                  height: '16px',
                  border: '2px solid #e5e7eb',
                  borderTopColor: '#3b82f6',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }}
              />
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </div>
          ) : (
            <>
              <button
                onClick={this.toggleFloatingMode}
                className="mb-2 px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
              >
                <FormattedMessage id="Expand Map" defaultMessage="Expand Map" />
              </button>
              {!isFloating && (
                <MiniMap
                  key={`minimap-${this.state.mapOpenCount}`}
                  currentLocation={this.state.currentLocation}
                  geocodedJobs={this.getAllJobsWithCoordinates()}
                  selectedPlace={this.state.selectedPlace}
                  showingInfoWindow={this.state.showingInfoWindow}
                  onMarkerClick={this.onMarkerClick}
                  onInfoWindowClose={this.onInfoWindowClose}
                  getMarkerColor={this.getMarkerColor}
                  markerRefs={this.markerRefs}
                  startGlobalDrag={this.startGlobalDrag}
                  mapTaskDndSource={this.state.mapTaskDndSource}
                  handleClickJobListItem={handleClickJobListItem}
                  toggleCoachmarksVisibility={this.props.toggleCoachmarksVisibility}
                  currentCoachmarkTarget={currentCoachmarkTarget}
                  sharedMapCenter={this.state.sharedMapCenter}
                  sharedMapZoom={this.state.sharedMapZoom - 1}
                  onMapReady={(map) => {
                    this.map = map;
                    // Only fit to markers when Job Map is opened, not when switching between views
                    if (this.shouldFitOnNextMount) {
                      this.shouldFitOnNextMount = false;
                      setTimeout(() => this.fitMapToMarkers(), 200);
                    }
                  }}
                />
              )}
            </>
          )}
        </div>

        <FloatingMap
          isVisible={isFloating}
          onClose={this.toggleFloatingMode}
          currentLocation={this.state.currentLocation}
          geocodedJobs={this.getAllJobsWithCoordinates()}
          selectedPlace={this.state.selectedPlace}
          showingInfoWindow={this.state.showingInfoWindow}
          onMarkerClick={this.onMarkerClick}
          onInfoWindowClose={this.onInfoWindowClose}
          getMarkerColor={this.getMarkerColor}
          markerRefs={this.markerRefs}
          startGlobalDrag={this.startGlobalDrag}
          mapTaskDndSource={this.state.mapTaskDndSource}
          handleClickJobListItem={handleClickJobListItem}
          toggleCoachmarksVisibility={this.props.toggleCoachmarksVisibility}
          currentCoachmarkTarget={currentCoachmarkTarget}
          sharedMapCenter={this.state.sharedMapCenter}
          sharedMapZoom={this.state.sharedMapZoom + 1}
          onMapReady={(map) => {
            this.map = map;
          }}
        />
      </div>
    );

    return (
      <CustomDropDown
        open={isJobListOpen}
        onOpenChange={() => {}}
        overlay={jobsLists}
        placement="right"
        className="flex-shrink-0"
        preventClosingOnLeave={true}
      >
        <button
          type="button"
          className="bg-gray-700 text-white pl-3 pr-2 py-1.5 rounded text-lg flex items-center cursor-pointer"
          onClick={() => this.setState({ isJobListOpen: !isJobListOpen })}
        >
          <FormattedMessage id="JOB MAP" defaultMessage="JOB MAP" />
          <ChevronRight className={`transform text-white ml-2 rotate-90`} />
        </button>
      </CustomDropDown>
    );
  }
}

JobListMap.propTypes = {
  schedulerData: PropTypes.object, // job board data
  newEvent: PropTypes.func, // current selected event
  taskDndSource: PropTypes.object,
  jobList: PropTypes.object, // jobs list
  getJobListAction: PropTypes.func, // fetches due this month jobs
  reportCategories: PropTypes.array, // all report categories
  handleClickJobListItem: PropTypes.func, // handles click event for job list item
  getMissedJobListAction: PropTypes.func, // fetches missed jobs
  missedJobs: PropTypes.object, // missed jobs
  getNextMonthJobListAction: PropTypes.func, // fetches next month jobs
  nextMonthJobs: PropTypes.object, // next month jobs
  runCoachMarks: PropTypes.func,
  toggleCoachmarksVisibility: PropTypes.func,
  currentCoachmarkTarget: PropTypes.string,
  onMapTaskDndSourceReady: PropTypes.func,
  onJobDrop: PropTypes.func,
  google: PropTypes.object,
  intl: PropTypes.object,
};

const mapStateToProps = ({
  jobListDetails,
  reportCategory,
  auth,
  signUpStatus,
}) => ({
  jobList: jobListDetails.jobList,
  missedJobs: jobListDetails.missedJobList,
  nextMonthJobs: jobListDetails.nextMonthJobList,
  reportCategories: Object.keys(reportCategory.reportData || {}),
  auth,
  currentCoachmarkTarget: signUpStatus.currentTarget,
});

const JobListMapContainer = connect(mapStateToProps, {
  getJobListAction,
  getMissedJobListAction,
  getNextMonthJobListAction,
  runCoachMarks,
  toggleCoachmarksVisibility,
})(injectIntl(JobListMap));

// Wrapper component to expose closeJobListMap method
class JobListMapWrapper extends React.Component {
  // NOSONAR: Method to close the JobListMap from outside
  closeJobListMap = () => {
    if (JobListMap.instance) {
      JobListMap.instance.closeJobListMap();
    }
  };

  render() {
    return <JobListMapContainer {...this.props} />;
  }
}

export default JobListMapWrapper;
